<fury-page-layout mode="card">
  <fury-page-layout-header>
    <fury-breadcrumbs [@fadeInRight] current="Customer-List"></fury-breadcrumbs>
  </fury-page-layout-header>

  <fury-page-layout-content [@fadeInUp]>
    <div class="block_area">
      <fury-common-kpi-blocks [mainPage]="'customers'" [data]="kpiData"></fury-common-kpi-blocks>
    </div>
    <div class="tab_section custom_list">
      <fury-list name={{filterValue}} [hideSearchInput]="true" [columns]="columns">
        
        <div class="actions">
          <button class="create" type="button" [routerLink]="['/consumers/add-customer']" mat-mini-fab color="primary">
            <mat-icon>add</mat-icon>
          </button>
        </div>
        <mat-tab-group animationDuration="0ms" (selectedTabChange)="tabChangeHandle($event)">
          <mat-tab label="All">
            <fury-customer-list [customerSearchForm]="customerSearchForm" [itemList]="itemList"
              [dataSource]="dataSource" [columns]="columns" [tabIndex]="isActive" [isLoading]="isLoading"
              (search)="search($event)"></fury-customer-list>
            <mat-paginator class="pegig" [pageSizeOptions]="[30, 50, 100, 2000]" [pageSize]="pageSize"
              [length]="totalCount" [pageIndex]="pageIndex" (page)="pageSizeChange($event)" showFirstLastButtons
              [selectConfig]="selectConfig" [ngClass]="{'mat-pegig': pageSize === 2000}"
              aria-label="Select page of periodic elements">
            </mat-paginator>

          </mat-tab>
          <mat-tab label="Active">
            <fury-customer-list [customerSearchForm]="customerSearchForm" [itemList]="itemList"
              [dataSource]="dataSource" [columns]="columns" [tabIndex]="isActive" [isLoading]="isLoading"
              (search)="search($event)"></fury-customer-list>
            <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount"
              [pageIndex]="pageIndex" (page)="pageSizeChange($event)" showFirstLastButtons [selectConfig]="selectConfig"
              [ngClass]="{'mat-pegig': pageSize === 9999}" aria-label="Select page of periodic elements">
            </mat-paginator>
          </mat-tab>
          <mat-tab label="Inactive">
            <fury-customer-list [customerSearchForm]="customerSearchForm" [itemList]="itemList"
              [dataSource]="dataSource" [columns]="columns" [tabIndex]="isActive" [isLoading]="isLoading"
              (search)="search($event)"></fury-customer-list>
            <mat-paginator [pageSizeOptions]="[30, 50, 100, 9999]" [pageSize]="pageSize" [length]="totalCount"
              [pageIndex]="pageIndex" (page)="pageSizeChange($event)" showFirstLastButtons [selectConfig]="selectConfig"
              [ngClass]="{'mat-pegig': pageSize === 9999}" aria-label="Select page of periodic elements">
            </mat-paginator>
          </mat-tab>
        </mat-tab-group>
      </fury-list>
    </div>


  </fury-page-layout-content>
</fury-page-layout>